import { withCompController } from '@wix/editor-elements-integrations';
import type { IResponsivePopupContainerStateRefsValues } from '../ResponsivePopupContainer.types';

export default withCompController<
  any,
  any,
  any,
  IResponsivePopupContainerStateRefsValues
>(({ mapperProps, stateValues }) => {
  const { setSiteScrollingBlocked } = stateValues;

  return {
    ...mapperProps,
    setSiteScrollingBlocked,
  };
});
